import type { SearchItemEntity } from '@iconik-io/shared-lib/src/redux/entities/normalized/search_item';

import { stateClasses } from './constants';

type Item = {
  isSelected?: boolean;
  isDragging?: boolean;
  isDropTarget?: boolean;
  status: SearchItemEntity['status'];
};

export const getStateClass = (
  item: Item | undefined,
): (typeof stateClasses)[keyof typeof stateClasses] | undefined => {
  if (!item) {
    return undefined;
  }
  const { status, isSelected, isDragging, isDropTarget } = item;
  if (status === 'DELETED') {
    return stateClasses.DELETED;
  }
  if (isDropTarget) {
    return stateClasses.TARGET;
  }
  if (isDragging) {
    return stateClasses.DRAGGING;
  }
  if (isSelected) {
    return stateClasses.SELECTED;
  }
  return stateClasses.DEFAULT;
};
